import React, { useEffect, useState } from 'react';
import './CompanyBankDetailList.scss';
import Pagination from '@material-ui/lab/Pagination';
import { Button, Container, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper, Box, Dialog, Card, CardContent } from '@material-ui/core';
import { http, FxInput, AlertService } from '../../../fx-core';
import { useHistory } from "react-router-dom";
import ConfirmDialog from '../../../general/ConfirmDialog/ConfirmDialog';

const CompanyBankDetailList = () => {
    const history = useHistory();

    let defaultFilter: any = {
        bankName: ''
    };

    let defaultPager: any = {
        startIndex: 0,
        pageCount: 0,
        pageNo: 1,
        totalRecords: 0,
        pagerInfo: '',
        pageSize: 25
    };

    const [companyBankDetails, setCompanyBankDetails] = useState([]);
    const [filter, setFilter] = useState(defaultFilter);
    const [pager, setPager] = useState(defaultPager);
    const [open, setOpen] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [message, setMessage] = useState(null);

    const computePagerData = (data, pagerOptions) => {
        let totalRecords = data.pagerResult.totalCount;
        let startNo = pagerOptions.startIndex + 1;
        startNo = totalRecords === 0 ? 0 : startNo;

        let endNo = pagerOptions.startIndex + pager.pageSize;
        endNo = endNo > totalRecords ? totalRecords : endNo;

        let pageCount = Math.ceil(totalRecords / pager.pageSize);
        let pagerInfo = `Showing ${startNo} - ${endNo} of ${totalRecords} items`;
        handlePagerChange({
            totalRecords, pageCount, pagerInfo,
            startIndex: pagerOptions.startIndex, pageNo: pagerOptions.pageNo
        });
    };

    const pageChanged = (event: object, page: number) => {
        getCompanyBankDetails({ pager: { pageNo: page } });
    };

    const handlePagerChange = (data) => {
        setPager(prevState => {
            return { ...prevState, ...data }
        });
    };

    const handleInputChange = (item) => {
        handleFilterChange({ [item.name]: item.value });
        let options = { pager: { pageNo: 1 }, filter: { [item.name]: item.value } };
        getCompanyBankDetails(options);
    };

    const handleFilterChange = (data) => {
        setFilter(prevState => {
            return { ...prevState, ...data }
        });
    };

    const getCompanyBankDetails = (options: any = {}) => {
        let startIndex = 0;
        let filters = {
            bankName: filter.bankName
        };

        if (options && options.pager) {
            startIndex = options.pager.pageNo === 1 ? 0 : ((options.pager.pageNo - 1) * pager.pageSize);
        }
        if (options && options.filter) {
            filters.bankName = options.filter.bankName;
        }

        let inputData = {
            filters,
            startIndex,
            pageSize: pager.pageSize,
        };
        let apiOptions: any = {
            url: `company/bankdetail/list`,
            data: inputData
        };
        http.post(apiOptions).then(res => {
            getCompanyBankDetailsCallBack(res, { startIndex, ...options.pager });
        })
    };

    const getCompanyBankDetailsCallBack = (res, pagerOptions) => {
        const result = res.data;
        setCompanyBankDetails(result.items);
        computePagerData(result, pagerOptions);
    };

    const showCompanyBankDetailForm = (item) => {
        let stateObj: any = { id: 0 };
        if (item && item.id) {
            stateObj = { ...stateObj, ...item }
        }
        history.push({
            pathname: '/companybankdetailform',
            state: stateObj
        });
    };

    const confirmDelete = (item: any) => {
        setSelectedItem(item);
        setMessage("Do you want to delete " + item.accountNo + "?");
        setOpen(true);
    };

    const confirmMessage = () => {
        setOpen(false);
        deleteCompanyBankDetail(selectedItem);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedItem({});
    }

    const deleteCompanyBankDetail = (item: any) => {
        let inputData = {
            id: item.id,
        };
        let apiOptions: any = {
            url: `company/bankdetail/${inputData.id}`
        };
        http.delete(apiOptions).then(response => {
            AlertService.showSuccessMsg();
            setSelectedItem({});
            getCompanyBankDetails();
        })
    }

    useEffect(() => {
        let options = { pager: { pageNo: 1 }, filter: filter };
        getCompanyBankDetails(options);
    }, []);

    return (
        <div className="content-container bankdetaillist-ui">
            <div className="title-font px-4 row justify-content-between py-1">
                <span className="pt-1">Company Bank Details</span>
                <span className="text-right add-ui" onClick={showCompanyBankDetailForm}><i className="fas fa-plus-circle"></i></span>
            </div>
            <div className="row col-12 mt-n1 pt-3 justify-content-between">
                <div className="col-sm-4 search mt-n1 pl-1">
                    <FxInput name="bankName" variant="outlined" label="Bank Name"
                        size="small"
                        value={filter.bankName}
                        onValueChange={handleInputChange}
                    />
                </div>
            </div>
            {/* <div className="row col-12 mt-1">
                <div className="col-8"></div>
                <div className="col-4">
                    <span className="float-right pt-2 pr-2">
                        <Button variant="contained" size="small" color="primary" onClick={showCompanyBankDetailForm}>Add</Button>
                    </span>
                </div>
            </div> */}

            <div className="px-2 col-sm-8 pl-3 mobileview pt-2">
                {
                    companyBankDetails.map((item, i) => (
                        <div key={i} className="card-ui py-2">
                            <Card>
                                <CardContent>
                                    <div className="row cardrow-ui">
                                        <span className="col-6">{item.accountName}</span>
                                        <span className="col-6 text-right">{item.accountNo}</span>                                        
                                    </div>
                                    <div className="row">
                                        <span className="col-4">{item.bankName}</span>
                                        <span className="col-4">{item.branchName}</span>
                                        <span className="col-4 text-right">{item.ifscCode}</span>
                                    </div>
                                    <div className="row justify-content-end">
                                        <span className="pl-3 pt-1">
                                            <div className="pb-1 px-2 btnstyle-ui pointer" onClick={() => showCompanyBankDetailForm(item)}>                                                            
                                                Edit                                                            
                                            </div>
                                        </span>
                                        <span className="pl-3 pt-1">
                                            <div className="pb-1 px-2 btnstyle-ui pointer" onClick={() => confirmDelete(item)}>                                                            
                                                Delete                                                            
                                            </div>
                                        </span>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    ))
                }
            </div>

            <div className="px-4 col-sm-12 pl-3 tabview pt-2">
                {
                    companyBankDetails.map((item, i) => (
                        <div key={i} className="card-ui py-2">
                            <Card>
                                <CardContent>
                                    <div className="row cardrow-ui">
                                        <span className="col-4">{item.accountName}</span>
                                        <span className="col-4">{item.accountNo}</span>                                        
                                    </div>
                                    <div className="row">
                                        <span className="col-4">{item.bankName}</span>
                                        <span className="col-4">{item.branchName}</span>
                                        <span className="col-4 text-right">{item.ifscCode}</span>
                                    </div>
                                    <div className="row justify-content-end pr-2">
                                        <span className="pl-3 pt-1">
                                            <div className="pb-1 px-2 btnstyle-ui pointer" onClick={() => showCompanyBankDetailForm(item)}>                                                            
                                                Edit                                                            
                                            </div>
                                        </span>
                                        <span className="pl-3 pt-1">
                                            <div className="pb-1 px-2 btnstyle-ui pointer" onClick={() => confirmDelete(item)}>                                                            
                                                Delete                                                            
                                            </div>
                                        </span>
                                    </div>
                                </CardContent>
                            </Card>
                        </div>
                    ))
                }
            </div>

            <div className="row deskview">
                <Container maxWidth="xl" className="mt-2">
                    <TableContainer component={Paper}>
                        <Table stickyHeader className="table table-striped">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="table-head table-font">Bank Name</TableCell>
                                    <TableCell className="table-head table-font">Account No</TableCell>
                                    <TableCell className="table-head table-font">Account Name</TableCell>
                                    <TableCell className="table-head table-font">IFSC Code</TableCell>
                                    <TableCell className="table-head table-font">Branch Name</TableCell>
                                    <TableCell width="14%" className="table-head table-font">Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    companyBankDetails.map((row, i) => (
                                        <TableRow key={i}>
                                            <TableCell>
                                                <div className="table-font">
                                                    {row.bankName}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="table-font">
                                                    {row.accountNo}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="table-font">
                                                    {row.accountName}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="table-font">
                                                    {row.ifscCode}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="table-font">
                                                    {row.branchName}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div className="btn-style">
                                                    <span className="table-font">
                                                        <Button variant="contained" size="small" color="primary"
                                                            onClick={() => showCompanyBankDetailForm(row)}> Edit
                                                        </Button>
                                                    </span>
                                                    <span className="table-font ml-3">
                                                        <Button variant="contained" size="small" color="primary"
                                                            onClick={() => confirmDelete(row)}> Delete
                                                        </Button>
                                                    </span>                                                    
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Container>
            </div>
           
            <div className="container pt-2 row col-12 justify-content-between mobileview">
                <div className="col-5 bottom-info pl-4">{pager.pagerInfo}</div>
                <div className="col-7 pr-0 mr-n4">
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    flex={1}
                    padding={0}
                    paddingRight={0}
                >
                    <Pagination
                        page={pager.pageNo}
                        count={pager.pageCount}
                        shape="rounded"
                        color="primary"
                        showFirstButton
                        showLastButton
                        boundaryCount={2}
                        onChange={pageChanged}
                    />
                </Box>
                </div>
            </div>
            <div className="container pt-2 row col-12 justify-content-between tabview">
                <div className="bottom-info pt-3 pl-4">{pager.pagerInfo}</div>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    flex={1}
                    padding={1}
                    paddingRight={0}
                >
                    <Pagination
                        page={pager.pageNo}
                        count={pager.pageCount}
                        shape="rounded"
                        color="primary"
                        showFirstButton
                        showLastButton
                        boundaryCount={2}
                        onChange={pageChanged}
                    />
                </Box>
            </div>
            <div className="container pt-2 row col-12 justify-content-between deskview">
                <div className="bottom-info pt-3 pl-4">{pager.pagerInfo}</div>
                <Box
                    display="flex"
                    justifyContent="flex-end"
                    flex={1}
                    padding={1}
                    paddingRight={1}
                >
                    <Pagination
                        page={pager.pageNo}
                        count={pager.pageCount}
                        shape="rounded"
                        color="primary"
                        showFirstButton
                        showLastButton
                        boundaryCount={2}
                        onChange={pageChanged}
                    />
                </Box>
            </div>
            <Dialog
                open={open}
                maxWidth="sm"
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <ConfirmDialog message={message} handleClose={handleClose} onConfirmCallback={confirmMessage} />
            </Dialog>
        </div>
    )
};

export default CompanyBankDetailList;